module.exports = __webpack_public_path__ + "static/media/S2N11-2.7a6a1721.svg";